import React from "react";
import { Link } from "react-router-dom";
import "./brandslider.css";
import br1 from '../../Assets/Banner/telephonIc.gif';
import br2 from '../../Assets/Brands/mdc.gif';
import br3 from '../../Assets/Brands/dt.gif';
import br4 from '../../Assets/Brands/lb.gif';

const BrandDisplay = () => {
  const categories = [
    { name: "Call now", imageUrl: br1, phone: "9120115166" },
    { name: "Buy Medicine", imageUrl: br2, link: "/AllMedicine" },
    { name: "Doctor Appointment", imageUrl: br3, link: "/doctorappoint" },
    { name: "Lab Test", imageUrl: br4, link: "/labtest" },
  ];

  return (
    <div className="brand-container-horizontal">
      {categories.map((item, index) => (
        <div key={index} className="brand-item-horizontal">
          {item.phone ? (
            <a
              href={`tel:${item.phone}`}
              className="brand-content-horizontal"
            >
              <div className="brand-icon-horizontal">
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  className="brand-image-horizontal"
                />
              </div>
              <p className="brand-name-horizontal">{item.name}</p>
            </a>
          ) : (
            <Link to={item.link} className="brand-content-horizontal">
              <div className="brand-icon-horizontal">
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  className="brand-image-horizontal"
                />
              </div>
              <p className="brand-name-horizontal">{item.name}</p>
            </Link>
          )}
        </div>
      ))}
    </div>
  );
};

export default BrandDisplay;